import { iconStates as iconStages } from '../core/pixi/icons';

export const spinTypes = {
  simple: 1,
  // reSpin:2,
  freeSpin: 3,
};

class SlotState {
  constructor() {
    this.reset();
    this.lastFreeRoundsCount = 0;
  }

  reset() {
    this.auto = false;
    this.freeSpin = false;
    this.spin = false;
    this.iconsState = iconStages.idle;
    this.moneyWinActions = false;
    this.waitingForTakeRequest = false;
    this.spinStopTime = 0;
    this.freeRounds = false;
    this.lastFreeSpinsCount = 0;
    this.respin = false;
    this.requestError = false;
    this.minSpinDurationTimer = null;
  }

  onSpinResponse(start = false) {
    // this.moneyWinActions = requests.getRoundWin();
    // const status = requests.getStatus();
    // const freeRoundsCount = requests.getFreeRoundCounts();
    // if (
    //   (start && freeRoundsCount > 0) ||
    //   (!start && freeRoundsCount - this.lastFreeRoundsCount > 0)
    // )
    //   this.freeRoundStartPopupStatus = popupStatuses.planned;
    // if (this.isFreeRoundsFinished()) {
    //   this.freeRoundFinishPopupStatus = popupStatuses.planned;
    // }
    // if (this.freeSpin && !requests.isFreeSpin()) this.freeSpinFinishStatus = popupStatuses.planned;
    // this.lastFreeRoundsCount = freeRoundsCount;
    // if (start && requests.isFreeRound()) this.freeRounds = true;
    // const freeSpinsCount = requests.getFreeSpinCount();
    // if (status === requestStatuses.FREESPIN && !this.freeSpin && freeSpinsCount) {
    //   this.freeSpinStartStatus = popupStatuses.planned;
    //   this.wonFeature = features.freeSpin;
    //   requests.prepareFeatureWinData(specialIcons.scatter);
    // } else if (
    //   status === requestStatuses.FREESPIN &&
    //   this.freeSpin &&
    //   freeSpinsCount - this.lastFreeSpinsCount >= 0
    // ) {
    //   this.extraFreeSpinsStatus = popupStatuses.planned;
    //   requests.prepareFeatureWinData(specialIcons.scatter);
    // } else {
    //   this.wonFeature = features.no;
    // }
    // if (status === requestStatuses.BONUS && !this.respin) {
    //   this.reSpinStartStatus = popupStatuses.planned;
    //   if (!start) this.wonFeature = features.bonus;
    //   requests.prepareFeatureWinData(specialIcons.moneyIcon);
    // }
    // if (this.respin && status !== requestStatuses.BONUS) {
    //   requests.prepareMultiplierData();
    //   this.reSpinFinishStatus = popupStatuses.planned;
    // }
    // this.lastFreeSpinsCount = freeSpinsCount;
    // if (!start) {
    //   this.transitionStageStatus = requests.hasAnotherCards()
    //     ? popupStatuses.planned
    //     : popupStatuses.none;
    //   // let hasScatterWin = requests.hasScatterWin();
    //   // if(!hasScatterWin && (requests.getFreeSpinCount() - this.lastFreeSpinsCount) > 0){
    //   //     requests.addScatterWinData();
    //   //     hasScatterWin = true;
    //   // }
    //   // this.scatterWinStageStatus = hasScatterWin ? popupStatuses.planned: popupStatuses.none;
    //   // this.multiplierWinStageStatus = this.freeSpin && requests.hasMultiplierWin() ? popupStatuses.planned: popupStatuses.none;
    // }
    // this.previous = requests.getMysteryIconNumber();
  }

  canStartSpin() {
    // return (
    //   gameState.current === gameStates.slot &&
    //   !this.spin &&
    //   !this.minSpinDurationTimer && //MIN
    //   !this.waitingForTakeRequest &&
    //   !this.requestError &&
    //   this.reSpinStartStatus === popupStatuses.none &&
    //   this.reSpinFinishStatus === popupStatuses.none &&
    //   (this.respin ||
    //     (this.freeSpinStartStatus === popupStatuses.none &&
    //       this.freeSpinFinishStatus === popupStatuses.none &&
    //       this.freeRoundFinishPopupStatus === popupStatuses.none &&
    //       this.extraFreeSpinsStatus === popupStatuses.none &&
    //       this.freeRoundStartPopupStatus !== popupStatuses.planned)) &&
    //   (!this.moneyWinActions || performance.now() - this.spinStopTime > 200) &&
    //   (this.winPopupStatus === popupStatuses.none || requests.getWinType() === winTypes.STANDARD) &&
    //   this.buyFeaturePopupStatus === popupStatuses.none
    // );
  }

  isFreeRoundsFinished() {
    // return (
    //   ((this.freeRounds && !requests.isFreeRound()) ||
    //     (requests.isFreeRound() && requests.getFreeRoundCounts() === 0)) &&
    //   (requests.getStatus() === requestStatuses.IDLE ||
    //     requests.getStatus() === requestStatuses.WIN)
    // );
  }

  onSpinStart() {} // MIN
}

export const slotState = new SlotState();

export function initSlotState() {
  // slotState.reset();
  // if (slotParams.minSpinDuration)
  //   slotState.onSpinStart = function () {
  //     //MIN
  //     if (!slotState.freeSpin && !slotState.respin) {
  //       slotState.minSpinDurationTimer = addToGameTimer(
  //         slotParams.minSpinDuration,
  //         onMinSpinDurationTimerEnd
  //       );
  //       gameEvents.emit('minSpinDurationTimerStarted');
  //     }
  //   };
}
function onMinSpinDurationTimerEnd() {
  // //MIN
  // slotState.minSpinDurationTimer = null;
  // gameEvents.emit('minSpinDurationTimerStopped');
}
